export default {
    dashboard: 'Dashboard',
    inquiryAttendance: 'Inquiry & Attendance',
    devicesManagement: 'Devices Management',
    employeeManagement: 'Employee Management',
    timeTableSetting: 'Timetable Setting',
    visitor: 'Visitor',
    blackList: 'Blacklist',
    nvrPunchLog: 'NVR Punch Log',
    systemActivityLog: 'Activity Log',
    logOut: 'Log Out',
    poweredBy: 'Powered by OKONTEK'
}
